module.exports = __webpack_public_path__ + "img/pannel_icon_white.7fe53bf8.svg";